<template>
  <el-dialog
    title="设备报警信息详情"
    :visible.sync="dialogTableVisible"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="400px"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="处理人">
        <el-input v-model.trim="form.handler" size="mini" disabled></el-input>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-tag type="success" v-if="form.status == 1">已处理</el-tag>
        <el-tag type="info" v-if="form.status == 2">误报</el-tag>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model.trim="form.result" size="mini" disabled></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain size="mini" @click="dialogTableVisible = false">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "ProtectDeviceManagementInfoDialog",
  props: {
    infoResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      form: {
        total: 0,
        list: []
      }
    };
  },
  created() {},
  mounted() {},
  watch: {
    infoResize: function(newVal, oldVal) {
      if (newVal) {
        this.getDetail();
        this.dialogTableVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.dialogTableVisible = false;
    },
    async getDetail() {
      let req = {
        eventId: this.info.eventId
      };
      let res = await this.$Http.getSafeEquipmentAlertDetail(req);
      if (res.code == 200) {
        this.form = res.data || {};
      } else if (res.code == 101) {
        this.form = {};
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination_box {
  // width: 100%;
  // height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
